export const STEPS = {
  INITIAL_STEP: 'INITIAL_STEP',
  PURCHASE_TRIAL: 'PURCHASE_TRIAL',
};
